var map = {
	"./account-icon.svg": 16751,
	"./arrow-down-tray-icon.svg": 3171,
	"./catalog-icon.svg": 18403,
	"./dashboard-icon-blue.svg": 17357,
	"./dashboard-icon.svg": 7796,
	"./dollar-icon.svg": 12702,
	"./identity-icon.svg": 98446,
	"./network-icon.svg": 48302,
	"./payments-icon.svg": 14475,
	"./pie-icon.svg": 58966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16400;